// tslint:disable:max-line-length
import classNames from "classnames";
import React from "react";
import { actions, Control } from "react-redux-form";
import { Dispatch } from "redux";
import _ from "underscore";

import { Errors } from "../../../../core/atoms/rrf";
import { CommonProps, EnquiryFormSection } from "./common";
import { FormProgressIcon } from "./formProgressIcon";

import "./notesField.scss";

interface OwnProps {
  dispatch: Dispatch<IWebStoreState>;
}

export class NotesField extends EnquiryFormSection<OwnProps> {
  protected shouldUpdateValidity(oldProps: CommonProps, newProps: CommonProps) {
    return !_.isEqual(oldProps.formState.notes, newProps.formState.notes);
  }

  protected syncValidity(formState: Forms.EnquiryForm) {
    this.props.dispatch(actions.setErrors(this.props.model, { required: !formState.notes || formState.notes.length < 1 }));
  }

  public render() {
    const { model, className, id } = this.props;

    return (
      <section id={id} className={classNames("notes-field", className)}>
        <header>
          <FormProgressIcon model={model} />
          <h2>Any comments?</h2>
          <p><strong>We're almost there!</strong> Please tell us as much as you can about your plans, and special requirements you may have. The more detail you provide, the more your local expert has to work with!</p>
          <p>In particular we'd like to know about any likes or dislikes you have about travelling, and any locations or experiences you definitely want to include in your itinerary.</p>
        </header>

        <div className="enquiry-form-question">
          <Errors model={model} messages={{ required: "Please tell us something" }} />

          <Control.textarea
            model={this.props.model}
            placeholder="Type your comments here. Don't be afraid to go into detail!"
            aria-label="Add your comments"
          />
        </div>
      </section>
    );
  }
}
